import React, {useState} from "react"
import "../App.css"
import axios from "axios"
import {SERVER_URI} from "../utility/config"
import LoginRequest from "./LoginRequest"

function UserManagement(props) {
	props.stopListRefresh()
	const [confirmUserId, setConfirmUserId] = useState(null)

	return (<div className="configurations">
			<span>
        <div className="discountRates">
	        {props.adminAccounts === undefined ? (<LoginRequest/>) : props.adminAccounts.length === 0 ? (
		        <h4>Ei käyttäjiä</h4>) : (<table id="discountTable">
		        <thead>
		        <tr>
			        <th>Nimi</th>
			        <th>Sähköposti</th>
		        </tr>
		        </thead>
		        <tbody>
		        {props.adminAccounts
			        .map((user) => (
				        <tr key={user.id}>
					        <td>{user.name}</td>
					        <td>{user.email}</td>
					        <td className="opration">
						        <button onClick={() => setConfirmUserId(user.id)}>
							        Poista
						        </button>
						        {confirmUserId === user.id && (<ConfirmDeleteAccount
							        userId={user.id}
							        handleClose={() => setConfirmUserId(null)} dispatch={props.dispatch}/>)}
					        </td>
				        </tr>))}
		        </tbody>
	        </table>)}
		        </div>
	        </span>
	</div>)
}

const ConfirmDeleteAccount = ({userId, handleClose, dispatch}) => {
	const [show, setShow] = useState(false)
	let storage = window.localStorage
	let userToken = storage.getItem("admin_token")

	const handleDeleteAccount = async (userId) => {
		try {
			await axios.delete(`${SERVER_URI}/delete_admin_account/${userId}`, {
				headers: {Authorization: `Token ${userToken}`},
			})
			setShow(true)
			setTimeout(() => {
				dispatch({type: "DELETE_ADMIN_ACCOUNT", data: {userId}})
				handleClose()
			}, 1700)
		} catch (e) {
			console.error("Error deleting user:", e)
		}
	}

	return (<div className="popUp_card">
		<div className="popup-box">
			<div className="box">
          <span className="close-icon" onClick={handleClose}>
            x
          </span>
				{!show && (<div>
					<h2 className="popUp_title">Poista käyttäjä</h2>
					<p>Oletko varma, että haluat poistaa käyttäjän?</p>
					<button onClick={handleClose}>Peruuta</button>
					<button onClick={() => handleDeleteAccount(userId)}>Kyllä, poista käyttäjä</button>
				</div>)}
				{show && (<OrderPriorityTimeCreatedMessage handleClose={handleClose}/>)}
			</div>
		</div>
	</div>)
}

export const OrderPriorityTimeCreatedMessage = (props) => {
	return (<div>
		<h2 className="message_title">Käyttäjä poistettu</h2>
	</div>)
}

export default UserManagement
